import UiErrorBoundary from './UiErrorBoundary';

export default UiErrorBoundary;
